import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import TopTabbar from "../partials/TopTabbar";
import Header from "../partials/Header";
import Footer from "../partials/Footer";
import DynamicForm from './DynamicForm';
import LoadingSpinner from '../../utils/LoadingSpinner';

const GeneralSettings = () => {
    const navigate = useNavigate();
    const [isPageLoading, setIsPageLoading] = useState(true);

    useEffect(() => {
        // Simuler un chargement de 2 secondes
        setTimeout(() => {
            setIsPageLoading(false);
        }, 2000);
    }, []);

    if (isPageLoading) {
        return <LoadingSpinner isVisible={true} loadingText="Chargement des paramètres..." />;
    }

    return (
        <>
            <div className="d-flex flex-column vh-100">
                <div className="flex-grow-1 overflow-y-scroll">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        maxWidth: '800px',
                        margin: '0 auto'
                    }}>
                        <div className="verify-number-main">
                            <TopTabbar />
                            <Header />
                            <div className="verify-number-top">
                                <div className="container">
                                    <div className="verify-number-top-content">
                                        <div className="back-btn" onClick={() => navigate(-1)}>
                                            <img src="assets/svg/header-white-icon.svg" alt="back-btn" />
                                        </div>
                                        <div className="header-title">
                                            <p>Paramétrages général des taux</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="verify-number-bottom">
                                <div className="container">
                                    <DynamicForm />
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GeneralSettings;
